import * as ResponsiveFns from './utilities/ResponsiveFns';
import * as CoreFns from './utilities/CoreFns';
import * as StandardFns from './utilities/StandardFns';
import * as TypeChecks from './TypeChecks';
import * as TypeEvaluation from './TypeEvaluation';
import * as SharedAcross from './utilities/SharedAcross';
import * as StyleFunctions from './utilities/StyleFunctions';
import * as TreeFunctions from './utilities/TreeFunctions';

function checkTwoTypesAreEqual(typeA, typeB){
  return JSON.stringify(typeA) === JSON.stringify(typeB);
}

function checkAnError(tree1, origAnswer, answer1, path, currentList, screenPath, organicChanges, upwardInfo, chains, changeTab){
  var gotConnectWallet = false;
  var gotToEtc = false;
  for (var i = 0; i < tree1.length; i++){
    var aQuestion = tree1[i];
    var loc = path.concat([aQuestion.i]);
    var answerHere = answer1[aQuestion.i];
    var conditions = aQuestion.c;
    var type = aQuestion.t;
    if (type){
      var p = checkSpecificTypeFully(type, origAnswer, aQuestion.f, conditions, answerHere, loc, currentList, screenPath, organicChanges, upwardInfo, chains, changeTab);
      if (p.loc){
        return p;
      }
      if (p.gotConnectWallet){
        gotConnectWallet = true;
      }      
      if (p.gotToEtc){
        gotToEtc = p.gotToEtc;
      }
    }else{
      console.log(type);
    }
  }  
  return {ok:1, gotConnectWallet, gotToEtc};     
}


function checkSpecificTypeFully(typeIn, origAnswer, f, conditions, answerHere, loc, currentList, screenPath, organicChanges, upwardInfo, chains, changeTab){
    var gotConnectWallet = false;
    var gotToEtc = false;

    var locBack = CoreFns.filterPathStopBefore(loc, loc.length - 1);
    var type1 = CoreFns.getType(typeIn, currentList, locBack);

    if (f && answerHere === undefined){
      if (type1.t === 'Boolean'){
      }else{
        return {loc, t:'Value Not Specified', screenPath};
      }
    }else if (f && answerHere.t === 'formula'){
      var equalTypes = checkTwoTypesAreEqual(type1, answerHere.r);
      if (!equalTypes){
        var changes = [{t:'w',w:loc.concat(['r']),n:type1}];
        organicChanges(changes);
      }

      var e1 = typeCheck(answerHere, answerHere.r, currentList, true, loc, screenPath, upwardInfo, chains);
      if (e1.loc){
        return e1;
      }
      if (e1.gotConnectWallet){
        gotConnectWallet = true;
      }
      if (e1.gotToEtc){
        gotToEtc = e1.gotToEtc;
      }
    }else{
      var type = CoreFns.getType(typeIn, currentList, locBack);
      if (type.t === 'Text String'){
        for (var j = 0; j < conditions.length; j++){
          var aCondition = conditions[j];
          if (aCondition.t === 'noBlank'){
            if (!answerHere || answerHere.length === 0){
              return {loc, t:'Cannot be blank', screenPath};
            }
          }else if (aCondition.t === 'characterLength'){
            if (!answerHere || answerHere.length !== aCondition.v){
              return {loc, t:aCondition.v + ' character length needed', screenPath};
            }
          }else if (aCondition.t === 'minCharacterLength'){
            if (!answerHere || answerHere.length < aCondition.v){
              return {loc, t:'At least ' + aCondition.v + ' character length needed', screenPath};
            }
          }else if (aCondition.t === 'startsWithLetter'){
            if (!SharedAcross.startsWithLetter(answerHere)){
              return {loc, t:'Need to start with a letter', screenPath};
            }
          }else if (aCondition.t === 'alphaNumeric'){
            if (!SharedAcross.isAlphaNumeric(answerHere)){
              return {loc, t:'Only numbers, letters and underscores allowed', screenPath};
            }
          }else if (aCondition.t === 'alphaNumericPlus'){
            if (!SharedAcross.isAlphaNumericPlus(answerHere)){
              return {loc, t:'Only numbers, letters, spaces, full stops, commas, and underscores allowed', screenPath};
            }
          }else if (aCondition.t === 'validHTML'){
            if (!SharedAcross.isValidHTML(answerHere)){
              return {loc, t:'Only numbers, letters, spaces, full stops, commas, and underscores allowed', screenPath};
            }
          }
        }
      }else if (type.t === 'Address'){
        if (!answerHere){
          return {loc, t:'Cannot be blank', screenPath};
        }else{
          if (!SharedAcross.isEthAddress (answerHere)){
            return {loc, t:'Invalid Address', screenPath};
          }
        }
      }else if (type.t === 'Transaction'){
        if (!answerHere){
          return {loc, t:'Cannot be blank', screenPath};
        }else{
          if (!SharedAcross.isEthTransaction (answerHere)){
            return {loc, t:'Invalid Transaction', screenPath};
          }
        }
      }else if (type.t === 'Integer' || type.t === 'UInteger' || type.t === 'Decimal'){
        if (type.t === 'UInteger' && type.sp === 'dateTime'){
          if (answerHere || answerHere === 0){
          }else{
            return {loc, t:'Date Time needed', screenPath};
          }
        }else if (type.t === 'Integer' || type.t === 'UInteger'){
          if (!SharedAcross.isIntegerText(answerHere)){
            return {loc, t:'Integer needed', screenPath};
          }
          if (type.t === 'UInteger'){
            if (!SharedAcross.isPositiveNumberOrZeroText(answerHere)){
              return {loc, t:'Positive Number or Zero needed', screenPath};
            }
          }
        }else if (type.t === 'Decimal'){
          var p1 = SharedAcross.isDecimalText(answerHere);
          if (!p1){
            return {loc, t:'Decimal needed', screenPath};
          }
        }
        for (var j1 = 0; j1 < conditions.length; j1++){
          var aCondition1 = conditions[j1];
          if (aCondition1.t === 'positiveOrZero'){
            if (!SharedAcross.isPositiveNumberOrZeroText(answerHere)){
              return {loc, t:'Positive Number or Zero needed', screenPath};
            }
          }else if (aCondition1.t === 'maxValue'){
            if (+ answerHere > aCondition1.v){
              return {loc, t:'Maximum of ' + aCondition1.v + ' allowed', screenPath};
            }
          }else if (aCondition1.t === 'minValue'){
            if (+ answerHere < aCondition1.v){
              return {loc, t:'Minimum of ' + aCondition1.v + ' allowed', screenPath};
            }
          }else if (aCondition1.t === 'positive'){
            if (+ answerHere <= 0){
              return {loc, t:'Positive number needed', screenPath};
            }
          }else if (aCondition1.t === 'strictlyGreaterThanVariable'){
            try{
              var answerHereToCheck = CoreFns.goDownPath(origAnswer, aCondition1.v, 0);
              if (+ answerHere > answerHereToCheck){
              }else{
                return {loc, t:aCondition1.txt, screenPath};
              }
            }catch(err){

            }
          }else{
            console.warn(aCondition1);
          }
        }
      }else if (type.t === 'ListType' || type.t === 'Object'){ 
        var quest = TreeFunctions.getQuestionsForObjectOrListType(currentList, type, 1);
        if (type.t === 'ListType'){
          if (!answerHere || !answerHere.s  || (typeof answerHere !== 'object')){
            answerHere = {s:{}};
            organicChanges([{t:'w',w:loc,n:answerHere}]);
          }
        }else if (type.t === 'Object'){
          if (!answerHere || (typeof answerHere !== 'object')){
            answerHere = {};
            organicChanges([{t:'w',w:loc,n:answerHere}]);
          }
        }

        var p61 = checkAnError(quest, origAnswer, answerHere, loc, currentList, screenPath, organicChanges, upwardInfo, chains, changeTab);
        if (p61.loc){
          return p61;
        }
        if (p61.gotConnectWallet){
          gotConnectWallet = true;
        }
        if (p61.gotToEtc){
          gotToEtc = p61.gotToEtc;
        }

      }else if (type.t === 'List'){
        if (answerHere){
          var keys = Object.keys(answerHere);
          for (var i1 = 0; i1 < keys.length; i1++){
            var aKey = keys[i1];
            var p4 = checkAnError(type.c, origAnswer, answerHere[aKey], loc.concat([aKey]), currentList, screenPath, organicChanges, upwardInfo, chains, changeTab);
            if (p4.loc){
              return p4;
            }
            if (p4.gotConnectWallet){
              gotConnectWallet = true;
            }
            if (p4.gotToEtc){
              gotToEtc = p4.gotToEtc;
            }
          }
          for (var j2 = 0; j2 < conditions.length; j2++){
            var aCondition2 = conditions[j2];
            var nos = 0;
            if (aCondition2.t === 'uniqueConditionalPath' || aCondition2.t === 'uniqueEndValues' || aCondition2.t === 'maxNos'){
              var vS = aCondition2.v;
              var uniqueAnswers = [];
              for (var i2 = 0; i2 < keys.length; i2++){
                var aKey2 = keys[i2];
                var thisPiece = answerHere[aKey2];
                var reachDown = [];
                var reachDownPath = [];
                var toSkip = false;
                for (var i3 = 0; i3 < vS.length; i3++){
                  var thisVs = vS[i3];
                  if (thisVs.t === 'conditional'){
                    var thisAns = thisPiece[thisVs.v].o;
                    thisPiece = thisPiece[thisVs.v].c[thisAns];
                    reachDownPath.push(thisVs.v);
                    reachDownPath.push('c');
                    reachDownPath.push(thisAns);
                    reachDown.push(thisAns);
                  }else if (thisVs.t === 'cond'){
                    var thisAns2 = thisPiece[thisVs.v].o;
                    if (oneOf(thisAns2, thisVs.c)){
                      reachDown.push(thisAns2);
                      reachDownPath.push(thisVs.v);
                      reachDownPath.push(thisPiece[thisVs.v].c);
                      reachDownPath.push(thisPiece[thisVs.v].c[thisAns2]);
                      thisPiece = thisPiece[thisVs.v].c[thisAns2];
                    }else{
                      toSkip = true;
                      break;
                    }
                  }else if (thisVs.t === 'path'){
                    if (thisPiece[thisVs.v]){
                      var thisAns1;
                      if (thisPiece[thisVs.v].t === 'formula'){
                        thisAns1 = thisPiece[thisVs.v].o;
                      }else{
                        thisAns1 = thisPiece[thisVs.v];
                      }
                      reachDown.push(thisAns1);
                      reachDownPath.push(thisVs.v);
                    }
                  }
                }
                if (!toSkip){
                  if (aCondition2.t === 'maxNos'){
                    if (reachDown[reachDown.length - 1] === aCondition2.i){
                      nos ++;
                    }
                    if (nos > aCondition2.nos){
                      return {loc:loc.concat([aKey]).concat(reachDownPath), t:aCondition2.e, screenPath};
                    }
                  }else{                  
                    var toCompare = '';
                    if (aCondition2.t === 'uniqueConditionalPath'){
                      toCompare = JSON.stringify(reachDown);
                    }else if (aCondition2.t === 'uniqueEndValues'){
                      toCompare = JSON.stringify(reachDown[reachDown.length - 1]);
                    }
                    for (var i4 = 0; i4 < uniqueAnswers.length; i4++){
                      if (toCompare === uniqueAnswers[i4]){
                        return {loc:loc.concat([aKey]).concat(reachDownPath), t:aCondition2.e, c:aCondition2, screenPath};
                        // return {loc:loc.concat([aKey]).concat(reachDownPath), t:aCondition2.e, c:aCondition2, screenPath};
                      }
                    }
                    uniqueAnswers.push(toCompare);
                  }
                }
              }  
            // if (aCondition2.t === 'uniqueConditionalPath'){
            //   var vS = aCondition2.v;
            //   var uniqueAnswers = [];
            //   for (var i2 = 0; i2 < keys.length; i2++){
            //     var aKey2 = keys[i2];
            //     var thisPiece = answerHere[aKey2];

            //     var reachDown = [];
            //     var reachDownPath = [];
            //     for (var i3 = 0; i3 < vS.length; i3++){
            //       var thisVs = vS[i3];
            //       if (thisVs.t === 'formula'){
            //         if (thisPiece[thisVs.v]){
            //           var thisAns1 = thisPiece[thisVs.v].o;
            //           reachDown.push(thisAns1);
            //           reachDownPath.push(thisVs.v);
            //         }
            //       }
            //     }
            //     var thisReachDownString = JSON.stringify(reachDown);
            //     for (var i4 = 0; i4 < uniqueAnswers.length; i4++){
            //       if (thisReachDownString === uniqueAnswers[i4]){
            //         return {loc:loc.concat([aKey]).concat(reachDownPath), t:aCondition2.e, screenPath, c:aCondition2};
            //       }
            //     }
            //     uniqueAnswers.push(thisReachDownString);
            //   }

            //     }
            //   }
            //   console.log(contracts);
            //   console.log(answerHere);   
            }else if (aCondition2.t === 'nosEntries'){
              if (keys.length !== aCondition2.v){
                var tt5;
                if (aCondition2.e){
                  tt5 = aCondition2.e;
                }else{
                  tt5 = 'Need ' + aCondition2.v + ' entries but ' + keys.length + ' have been created.';
                }
                return {loc, screenPath, t:tt5}
              }
            }else{
              console.warn(aCondition2);
            }
          }

        }

      }else if (type.t === 'Boolean' ){
      }else if (TreeFunctions.isDynamicChoice(type)){


        var sets = TreeFunctions.actionOptionChoices(type, currentList, loc);

        if (!answerHere || answerHere.i === undefined){
          answerHere = {i:'',subs:{}};
          if (type.t === 'Type'){
            answerHere.i = 'UInteger';
          }
          organicChanges([{t:'w',w:loc,n:answerHere}])
        }
        
        var haveFound = false;
        for (var i5 = 0; i5 < sets.length; i5++){
          var thisAction = sets[i5];
          if (thisAction.i === answerHere.i){
            haveFound = true;
            var x = checkAnError(thisAction.c, origAnswer, answerHere.subs, loc.concat(['subs']), currentList, screenPath, organicChanges, upwardInfo, chains, changeTab);
            if (x.loc){
              return x;
            }
            break;
          }
        }
        if (!haveFound){
          return {loc, screenPath, t:'Please select an option'};
        }
      }else if (type.t === 'Action'){

        var haveFound4 = false;
        if (answerHere){

          var sets1 = TreeFunctions.actionOptions(currentList, loc);
          for (var i16 = 0; i16 < sets1.length; i16++){
            if (sets1[i16].i === answerHere.t){
              haveFound4 = true;
              break;
            }
          }
          if (answerHere.t === 'connectWallet'){
            gotConnectWallet = true;
          }
          var p7 = checkAnOc(loc, currentList, answerHere, screenPath, organicChanges, upwardInfo, chains, changeTab);
          if (p7.loc){
            return p7;
          }
          if (p7.gotConnectWallet){
            gotConnectWallet = true;
          }
          if (p7.gotToEtc){
            gotToEtc = p7.gotToEtc;
          }
          if (!haveFound4){
            return {loc, screenPath, t:'Please select an option'};
          }

        }


      }else if (type.t === 'AddressCSV'){
        if (answerHere){
        }else{
          return {loc, t:'Missing Whitelist', screenPath};
        }
      }else if (type.t === 'Variable'){
        if (answerHere){
          if (answerHere.indexOf('ov_') === 0){
            var ovHere = answerHere.substr(3);
            var ov = currentList.ov;
            var ovHereA = ov[ovHere];
            if (ovHereA){
            }else{
              return {loc, screenPath, t:'Your original selection has been deleted. Please select an option'};
            }
          }
        }else{
          return {loc, screenPath, t:'Please select an option'};
        }
      }else if (type.t === 'ScEvent' || type.t === 'Execute' || type.t === 'PlayMusic'){

      }else if (type.t === 'Conditional'){
        var options = type.o;
        var haveFoundAnswer = false;
        if (answerHere){
          for (var i21 = 0; i21 < options.length; i21++){
            var anOption = options[i21];
            if (anOption.i === answerHere.o){
              haveFoundAnswer = true;
              var p21 = checkAnError(anOption.c, origAnswer, CoreFns.getFollowUp(answerHere), loc.concat(['c', answerHere.o]), currentList, screenPath, organicChanges, upwardInfo, chains, changeTab);
              if (p21.loc){
                return p21;
              }
              break;
            }
          }
        }
        if (!haveFoundAnswer){
          return {loc, t:'Need to select answer', screenPath};
        }

        for (var j25 = 0; j25 < conditions.length; j25++){
          var aCondition25 = conditions[j25];
          // if (aCondition25.t === 'notEqual'){
          //   var loc5 = CoreFns.filterPathStopBefore(path, path.length - aCondition25.back);
          //   var loc6 = loc5.concat(aCondition25.down);
          //   var compare = CoreFns.goDownPath(currentList, loc6);
          //   if (CoreFns.stringifyIfObject(answerHere) === CoreFns.stringifyIfObject(compare)){
          //     return {loc, t:aCondition25.msg, screenPath};
          //   }
          // }else{
            console.warn(aCondition25);
          // }
        }

      }else{
        console.warn(type);
      }

    }

    return {gotToEtc, gotConnectWallet};
}
function smartContractChecks(currentList, organicChanges){

  var smartContracts = currentList.sc;
  if (smartContracts){
    var smartContractKeys = Object.keys(smartContracts);
    for (var i = 0; i < smartContractKeys.length; i++){
      var scPath = ['sc', smartContractKeys[i]]
      var chainId = CoreFns.relevantChainId(currentList);
      var l4 = ['sc', smartContractKeys[i], 'addSet', chainId];
      var l5 = ['sc', smartContractKeys[i], 'addSet', chainId, 'addr'];
      var contractInfo = CoreFns.getContractInfo(currentList, smartContractKeys[i]);
      if (contractInfo){
        var chainInfo = CoreFns.goDownPath(currentList, l4);
        if (chainInfo && chainInfo.addr){
        }else{
          return {loc:l5, screenPath:scPath, t:'Contract on wrong chain'};
        }
      }else{
        return {loc:l5, screenPath:scPath, t:'Contract on wrong chain'};
      }
    }

  }
  return {ok:1};  
}

export function checkErrors(currentList, organicChanges, sessionID, signKey, userID, chains, changeTab){
  
  if (!currentList){
    return false;
  }
  var p = smartContractChecks(currentList, organicChanges);
  if (p.loc){
    return p;
  }

  var defaultFE = currentList._g.ss;

  var frontEnds = currentList.fe;
  var frontEndKeys = Object.keys(frontEnds);
  if (!frontEnds[defaultFE] && frontEndKeys.length > 1){
    return {loc:['noDefaultScreen'], screenPath:['fe'], t:'Need to choose default screen'};
  }


  var gotConnectWallet = false;
  var gotToEtc = false;

    var sets = [{t:'ov', q:TreeFunctions.ownVariableQuestions()}, {t:'mu', q:TreeFunctions.musicQuestions()}];
    for (var i21 = 0; i21 < sets.length; i21++){
      var thisSet = sets[i21];
      var ownVariablesX = currentList[thisSet.t]
      if (ownVariablesX){
        var e = checkAnError(thisSet.q, currentList, currentList, [], currentList, [thisSet.t], organicChanges, [], chains, changeTab);
        if (e.loc){
          return e;
        }
        if (e.gotConnectWallet){
          gotConnectWallet = true;
        }
        if (e.gotToEtc){
          gotToEtc = e.gotToEtc;
        }      
      }

    }

    var oc = currentList.oc;
    if (oc){
      var ocKeys = Object.keys(oc);
      for (var i10 = 0; i10 < ocKeys.length; i10++){
        var aKey = ocKeys[i10];
        var ocLoc = ['oc',aKey];
        var e3 = checkAnOc( ocLoc, currentList, oc[aKey], [], organicChanges, [], chains, changeTab);
        if (e3.loc){
          return e3;
        }
        if (e3.gotConnectWallet){
          gotConnectWallet = true;
        }
        if (e3.gotToEtc){
          gotToEtc = e3.gotToEtc;
        }
      }
    }


    if (currentList.fo){
      if (currentList.fo.on){
        var footerItems = currentList.fo.k;
        var footerKeys = Object.keys(footerItems);
        for (var j16 = 0; j16 < footerKeys.length; j16++){
          var thisItemKey6 = footerKeys[j16];
          var thisPath6 = ['fo', 'k', thisItemKey6];
          var anItem6 = footerItems[thisItemKey6];
          var x6 = checkAnItem(anItem6, thisItemKey6, thisPath6, currentList, organicChanges, chains, changeTab);
          if (x6.loc){
            return x6;
          }
          if (x6.gotToEtc){
            gotToEtc = x6.gotToEtc;
          }
          if (x6.gotConnectWallet){
            gotConnectWallet = true;
          }
        }
      }
    }

    for (var i = 0; i < frontEndKeys.length; i++){
      var allPanelsPath = ['fe', frontEndKeys[i], '_s'];
      var fePath = ['fe', frontEndKeys[i]];
      var thisFE = CoreFns.goDownPath(currentList, fePath);

      var p4 = parseAnObject('PAGE', fePath, currentList, fePath, organicChanges, [], chains, changeTab);
      if (p4.loc){
        return p4;
      }

      if (thisFE.nv && thisFE.nv.on){

        var nvItems;
        var nvHolderPath;

        if (thisFE.nv.on === 1){
          nvItems = thisFE.nv;
          nvHolderPath = fePath;
        }else{
          var cn = currentList.cn;
          if (cn){
            var nvCheck = cn[thisFE.nv.on];
            nvHolderPath = ['cn', thisFE.nv.on];
            if (!nvCheck){
              var changes1 = [{t:'w', w:fePath.concat(['nv', 'on']), n:0}];
              organicChanges(changes1);            
              return {loc:fePath, screenPath:fePath, t:'Common Nav Bar deleted.'};
            }

            if (nvCheck.nv && nvCheck.nv.on){

              var alternates = Object.keys(cn);
              var newPush = '';
              for (var i15 = 0; i15 < alternates.length; i15++){
                if (alternates[i15] !== nvCheck.nv.on){
                  newPush = alternates[i15];
                  break;
                }
              }
              
              

              var changes = [];
              if (newPush){
                changes = [{t:'w',w:fePath.concat(['nv', 'on']),n:newPush}];
                nvItems = currentList.cn[newPush].nv;
                nvHolderPath = ['cn', newPush];
                organicChanges(changes);            
              }else{
                changes = [{t:'r', w:['cn'], i:thisFE.nv.on}];
                organicChanges(changes);            
                return {loc:fePath, screenPath:fePath, t:'Common Nav Bar deleted X.'};

              }
            }else if (nvCheck.nv){
              nvItems = currentList.cn[thisFE.nv.on].nv;   
            }
          }
        }

        var toCheck = ['i'];
        if (nvItems.s.navbarCluster){
          if (nvItems.ic){
            toCheck.push('ic');
          }
          if (nvItems.ir){
            toCheck.push('ir');
          }

        }

        for (var j5 = 0; j5 < toCheck.length; j5++){
          var nvItemsI = nvItems[toCheck[j5]];
          var nvItemKeys = Object.keys(nvItemsI);
          for (var j1 = 0; j1 < nvItemKeys.length; j1++){
            var nvPath = nvHolderPath.concat(['nv', toCheck[j5], nvItemKeys[j1]]);
            var thisNavItem = nvItemsI[nvItemKeys[j1]];
            var p6 = parseAnObject(thisNavItem.t, nvPath, currentList, nvPath, organicChanges, [], chains, changeTab);
            if (p6.loc){
              return p6;
            }
            if (p6.gotToEtc){
              gotToEtc = p6.gotToEtc;
            }
            if (p6.gotConnectWallet){
              gotConnectWallet = true;
            }

          }

        }
      }

      var  panels = CoreFns.goDownPath(currentList, allPanelsPath, 0);

//do front end style.

      var panelKeys = Object.keys(panels);
      for (var k = 0; k < panelKeys.length; k++){
        var jPath = allPanelsPath.concat([panelKeys[k]]);
        var thisPanel = CoreFns.goDownPath(currentList, jPath, 0);

        var p41 = parseAnObject('PANEL', jPath, currentList, jPath, organicChanges, [], chains, changeTab);
        if (p41.loc){
          return p41;
        }

        var alerts = thisPanel.al;
        if (alerts){
          var alertKeys = Object.keys(alerts);
          for (var j3 = 0; j3 < alertKeys.length; j3++){
            var thisAlertPath = jPath.concat(['al', alertKeys[j3]]);

            var p3 = parseAnObject('alert', thisAlertPath, currentList, thisAlertPath, organicChanges, [], chains, changeTab);
            if (p3.loc){
              return p3;
            }

            if (p3.gotToEtc){
              gotToEtc = p3.gotToEtc;
            }
            if (p3.gotConnectWallet){
              gotConnectWallet = true;
            }

            var kPieces = alerts[alertKeys[j3]].k;
            var kKeys = Object.keys(kPieces);
            for (var j10 = 0; j10 < kKeys.length; j10++){
              var anItemJ = kPieces[kKeys[j10]];
              var p25 = doHoldPieces(anItemJ, thisAlertPath.concat(['k', kKeys[j10]]), currentList, organicChanges, chains, changeTab);
              if (p25.loc){
                return p25;
              }
              if (p25.gotToEtc){
                gotToEtc = p25.gotToEtc;
              }
              if (p25.gotConnectWallet){
                gotConnectWallet = true;
              }
            }

            var p7 = checkAnEntity(currentList, thisAlertPath.concat(['k']), organicChanges, [], chains, changeTab);
            if (p7.loc){
              return p7;
            }

            if (p7.gotToEtc){
              gotToEtc = p7.gotToEtc;
            }
            if (p7.gotConnectWallet){
              gotConnectWallet = true;
            }

          }

          if (p4.gotToEtc){
            gotToEtc = p4.gotToEtc
          }
          if (p4.gotConnectWallet){
            gotConnectWallet = true;
          }

          var items = thisPanel.i;
          var itemKeys = Object.keys(items);
          for (var j = 0; j < itemKeys.length; j++){
            var thisItemKey = itemKeys[j];
            var thisPath = jPath.concat(['i', thisItemKey]);
            var anItem = items[thisItemKey];
            var x = checkAnItem(anItem, thisItemKey, thisPath, currentList, organicChanges, chains, changeTab);
            if (x.loc){
              return x;
            }
            if (x.gotToEtc){
              gotToEtc = x.gotToEtc;
            }
            if (x.gotConnectWallet){
              gotConnectWallet = true;
            }
          }

          var p20 = doRel(thisPanel, jPath, currentList, organicChanges, chains, changeTab);
          if (p20.loc){
            return p20;
          }
          if (p20.gotToEtc){
            gotToEtc = p20.gotToEtc;
          }
          if (p20.gotConnectWallet){
            gotConnectWallet = true;
          }

        }
      }
    }

  if (gotToEtc && !gotConnectWallet){
    return {loc:gotToEtc.entityPath, screenPath:gotToEtc.screenPath, t:'Need to enable the user to connect wallet. You can do so by adding a button element, and set a Connect Wallet action when it is clicked.'};
  }

  return false;
}

function doRel(thisPanel, jPath, currentList, organicChanges, chains, changeTab){

  var gotConnectWallet = false;
  var gotToEtc = false;

  var relItems = thisPanel.k;
  if (relItems){

    var currentOrder = -Infinity;
    var relItemKeys = ResponsiveFns.sortAListBasedOnOrd(relItems);

    // var relItemKeys = Object.keys(relItems);
    for (var j15 = 0; j15 < relItemKeys.length; j15++){
      var thisItemKey5 = relItemKeys[j15];
      var thisPath5 = jPath.concat(['k', thisItemKey5]);
      var anItem5 = relItems[thisItemKey5];
      if (anItem5.s && anItem5.s.ord){
        var thisOrd = anItem5.s.ord.v;
        if (thisOrd > currentOrder){
          currentOrder = thisOrd;
        }else{
          return {loc:thisPath5, screenPath:thisPath5, t:'Invalid Ordering'};
        }
      }

      var x5 = checkAnItem(anItem5, thisItemKey5, thisPath5, currentList, organicChanges, chains, changeTab);
      if (x5.loc){
        return x5;
      }
      if (x5.gotToEtc){
        gotToEtc = x5.gotToEtc;
      }
      if (x5.gotConnectWallet){
        gotConnectWallet =  true;
      }
    }
  }

  return {ok:1, gotConnectWallet, gotToEtc};

}

function checkAnItem(anItemJ, thisItemKey, thisPath, currentList, organicChanges, chains, changeTab){

  var gotConnectWallet = false;
  var gotToEtc = false;
    var p2 = parseAnObject(anItemJ.t, thisPath, currentList, thisPath, organicChanges, [], chains, changeTab);
    if (p2.loc){
      return p2;
    }

    if (p2.gotToEtc){
      gotToEtc = p2.gotToEtc;
    }
    if (p2.gotConnectWallet){
      gotConnectWallet = true;
    }

    if (anItemJ.t === 'DIV'){
      var p1 = checkAnEntity(currentList, thisPath, organicChanges, [], chains, changeTab);
      if (p1.loc){
        return p1;
      }

      if (p1.gotToEtc){
        gotToEtc = p1.gotToEtc;
      }
      if (p1.gotConnectWallet){
        gotConnectWallet = true;
      }

    }else if (CoreFns.isHolder(anItemJ.t)){
      var p25 = doHoldPieces(anItemJ, thisPath, currentList, organicChanges, chains, changeTab);
      if (p25.loc){
        return p25;
      }
      if (p25.gotToEtc){
        gotToEtc = p25.gotToEtc;
      }
      if (p25.gotConnectWallet){
        gotConnectWallet = true;
      }

    }


    return {gotToEtc, gotConnectWallet};
}

function doHoldPieces(anItemJ, thisPath, currentList, organicChanges, chains, changeTab){

  var gotConnectWallet = false;
  var gotToEtc = false;
  var cardPieces = anItemJ.i;
  var cardPiecesKeys = Object.keys(cardPieces);
  for (var j = 0; j < cardPiecesKeys.length; j++){
    var cardKey = cardPiecesKeys[j];
    var thisCardPath = thisPath.concat(['i', cardKey]);
    var anItem = cardPieces[cardKey];
    var x = checkAnItem(anItem, cardKey, thisCardPath, currentList, organicChanges, chains, changeTab);
    if (x.loc){
      return x;
    }
    if (x.gotToEtc){
      gotToEtc = x.gotToEtc;
    }
    if (x.gotConnectWallet){
      gotConnectWallet = true;
    }
  }
  return {ok:1, gotConnectWallet, gotToEtc};
}
function gatherAllEntitiesUsed(currentList, screenPath, organicChanges){

   var entitiesUsed = {};

   function walkDownAnEntity(entity){
    if (!entity){
      return;
    }else{
      var x = entity.x;
      if (x){
        x.forEach((anX, index)=>{
          if (anX.t === 'a'){
            if (!entitiesUsed[anX.i]){
              if (anX.i !== '_g'){
                entitiesUsed[anX.i] = anX.n;
                var thisEntity = CoreFns.goDownPath(currentList, ['as', anX.i], 0);
                walkDownAnEntity(thisEntity);                
              }
            }
          }
        })


      }
    }
   }

  var thisEntity = CoreFns.goDownPath(currentList, screenPath, 0);
  walkDownAnEntity(thisEntity);
  return entitiesUsed;
 
}


function checkAnEntity(currentList, screenPath, organicChanges, upwardInfo, chains, changeTab){
  var gotConnectWallet = false;
  var gotToEtc = false;
  var allEntitiesUsed = gatherAllEntitiesUsed(currentList, screenPath, organicChanges);  
  var aKeys = Object.keys(allEntitiesUsed);
  for (var i = 0; i < aKeys.length; i++){
    var path = ['as', aKeys[i]];
    var e = parseAnObject('SPAN', path, currentList, screenPath, organicChanges, upwardInfo, chains, changeTab);
    if (e.loc){
      return e;
    }
    if (e.gotConnectWallet){
      gotConnectWallet = true;
    }
    if (e.gotToEtc){
      gotToEtc = e.gotToEtc;
    }
  }

  var e1 = parseAnObject('DIV', screenPath, currentList, screenPath, organicChanges, upwardInfo, chains, changeTab);
  if (e1.loc){
    return e1;
  }
  if (e1.gotConnectWallet){
    gotConnectWallet = true;
  }
  if (e1.gotToEtc){
    gotToEtc = e1.gotToEtc;
  }

  return {ok:1, gotConnectWallet, gotToEtc};
}

function typeCheck(aStyle, typeR, currentList, confirmCheck, entityPath, screenPath, upwardInfo, chains){
  var gotToEtc = false;
  if (aStyle.t === 'formula' || confirmCheck){
    var styleErrorCheck = checkFormulaMatchesType(aStyle.o, typeR, currentList, upwardInfo, entityPath, screenPath, chains);
    if (styleErrorCheck.loc){
      return styleErrorCheck;
    }
    var x1 = checkIfGotTokNftOrSC(aStyle.o);
    if (x1){
      gotToEtc = {entityPath, screenPath};
    }
  }else{

  }
  return {ok:1, gotToEtc};  
}

function checkIfGotTokNftOrSC(form){
  var ft = form.t;
  if (ft === 'eS' || ft === 'eV'){
    return true;
  }else if (ft === 'f'){
    if (form.i === 106){
      return true;
    }
    var v = form.v;
    for (var i = 0; i < v.length; i++){
      var p = checkIfGotTokNftOrSC(v[i]);
      if (p){
        return p;
      }
    }  
  }else if (ft === 's' || ft === 'i' || ft === 'ui' || ft === 'dt' || ft === 'dc' || ft === 'ad' || ft === 'ca' || ft === 'pu' || ft === 'gi'  || ft === 'scr'  || ft === 'mus' || ft === 'coin' || ft === 'curr' || ft === 'footer' || ft === 'pa' || ft === 'al' || ft === 'pl' ){
  }else if (CoreFns.withP(ft)){
    var pathDown = form.p;
    for (var j = 0; j < pathDown.length; j++){
      var aPath = pathDown[j];
      if (aPath.t === 'oP'){
      }else{
        var p2 = checkIfGotTokNftOrSC(aPath);
        if (p2){
          return p2;
        }
      }
    }
  }else{
    console.warn(form);
  }

  return false;
}

function parseAnObject(objType, path, currentList, screenPath, organicChanges, upwardInfo, chains, changeTab){

  var gotConnectWallet = false;
  var gotToEtc = false;
  if (path[path.length - 1] === '_g'){
    return {ok:1, gotConnectWallet, gotToEtc};
  }

  var objectToCheck = CoreFns.goDownPath(currentList, path, 0);
  if (objectToCheck){

    var styles = objectToCheck.s;
    if (styles){
      var styleKeys = StyleFunctions.getPotentials(objType, styles, path, currentList);

      for (var i0 = 0; i0 < styleKeys.length; i0++){
        var aStyleKey = styleKeys[i0];
        var aStyle = styles[aStyleKey];
        var e0 = null;
        if (aStyle && aStyle.t){
          e0 = typeCheck(aStyle, aStyle.r, currentList, false, path.concat(['s', aStyleKey]), screenPath, upwardInfo, chains);
        }else{
          var type = null;
          if (StyleFunctions.isRawTextStyle(aStyleKey)){
            type = {t:'Text String'};
          }else if (StyleFunctions.isRawBooleanStyle(aStyleKey)){
            type = {t:'Boolean', v:1};
          }else if (StyleFunctions.isRawIntegerStyle(aStyleKey) || aStyleKey === 'zIndex'){
            type = {t:'Integer'};
          }else if (StyleFunctions.isRawUIntegerStyle(aStyleKey)){
            type = {t:'UInteger'};
          }else if (StyleFunctions.isRawDecimalStyle(aStyleKey)){
            type = {t:'Decimal'};
          }
          var conditions = [];

          if (aStyleKey === 'videoId' || aStyleKey === 'minValErrorText' || aStyleKey === 'maxValErrorText'){
            conditions = [{t:'noBlank'}];
          }
          if (type){
            e0 = checkSpecificTypeFully(type, 'notUsed', 1, conditions, aStyle, path.concat(['s', aStyleKey]), currentList, screenPath, organicChanges, upwardInfo, chains, changeTab);          
          }
        }
        if (e0){
          if (e0.loc){
            return e0;
          }
          if (e0.gotConnectWallet){
            gotConnectWallet = true;
          }
          if (e0.gotToEtc){
            gotToEtc = e0.gotToEtc;
          }

        }
      }
    }

    var oc = objectToCheck.oc;
    if (oc){
      var ocKeys = Object.keys(oc);
      for (var i10 = 0; i10 < ocKeys.length; i10++){
        var aKey = ocKeys[i10];
        var ocLoc = path.concat(['oc',aKey]);
        var e3 = checkAnOc(ocLoc, currentList, oc[aKey], screenPath, organicChanges, upwardInfo, chains, changeTab);
        if (e3.loc){
          return e3;
        }
        if (e3.gotConnectWallet){
          gotConnectWallet = true;
        }
        if (e3.gotToEtc){
          gotToEtc = e3.gotToEtc;
        }
      }
    }
  

  }


  return {ok:1, gotConnectWallet, gotToEtc};
}

function checkAnOc(ocLoc, currentList, answer, screenPath, organicChanges, upwardInfo, chains, changeTab){

  var tree = ResponsiveFns.getQuestionsOfACurrentAnswer(currentList, ocLoc, answer, chains, changeTab);
  if (!tree){
    return {t:'Option no longer available', loc:ocLoc, screenPath};
  }
  var e = checkAnError(tree, answer, answer, ocLoc, currentList, screenPath, organicChanges, upwardInfo, chains, changeTab);
  if (answer.t === 'connectWallet'){
    e.gotConnectWallet = true;
  }else if (answer.t.indexOf('existingContractFn') === 0 ){

    if (answer.t.indexOf('existingContractFn') === 0){

      var parts = answer.t.split(' ');
      var contractInfoAbi = CoreFns.getContractInfoAbi(currentList, parts[1]);
      if (answer.If_Succeed && answer.If_Succeed.t){
        if (answer.trig){
          var thisAbiNew = CoreFns.getAbiFnInfo(contractInfoAbi, answer.trig.i, true);
          if (thisAbiNew){
            var inputs = thisAbiNew.inputs;
            for (var i = 0; i < inputs.length; i++){
              var thisInput = inputs[i];
              if (thisInput.indexed){
                var inputType = TypeEvaluation.convertSCTypeToInternalType(thisInput);
                var origA = answer.trig.subs[thisInput.name];
                if (origA && origA.o === '1'){
                  var followUps = CoreFns.getFollowUp(origA);
                  var inside = followUps.v;
                  if (inputType){
                    var p = checkSpecificTypeFully(inputType, inside, 1, [], inside, ocLoc.concat(['trig', 'subs', thisInput.name, 'c', '1', 'v']), currentList, screenPath, organicChanges, upwardInfo, chains, changeTab);
                    if (p.loc){
                      return p;
                    }                    
                  }else{
                    console.log(inputType);
                  }
                }                
              }
            }
          }
        }else{
          return {t:'Trigger not specified', loc:ocLoc.concat(['If_Succeed']), screenPath};
        }
      }
    }
    e.gotToEtc = {entityPath:ocLoc, screenPath};
  }
  return e;

}

function extractAnyOrMatchTypes(searchType, matchType){
  if (matchType.t === 'any' || matchType.t === 'free' || matchType.t === 'nos'){
    return [{n:matchType.v, s:searchType}];
  }else if (matchType.t === 'ListType' && searchType.t === 'ListType'){
    return extractAnyOrMatchTypes(searchType.c, matchType.c);
  }else if (matchType.t === 'MaybeSpecified' && searchType.t === 'MaybeSpecified'){
    return extractAnyOrMatchTypes(searchType.c[0], matchType.c[0]);
  }else if (matchType.t === 'Object' && searchType.t === 'Object'){
    var set = [];
    for (var i = 0; i < matchType.c.length; i++){
      var manO = matchType.c[i];
      for (var j = 0; j < searchType.c.length; j++){
        var saO = searchType.c[j];
        if (manO.ti === saO.ti){
          var p = extractAnyOrMatchTypes(saO, manO);
          set = set.concat(p);
          break;
        }
      }
    }
    return set;
  }else{
    return [];
  }
}

function replaceAnInType(nos, replaceWith, inType){
  if (inType.t === 'free' || inType.t === 'match'){
    if (nos === inType.v){
      return replaceWith;
    }else{
      return inType;
    }
  }else if (inType.t === 'ListType' ){
    return {t:inType.t, c:replaceAnInType(nos, replaceWith, inType.c)};
  }else if (inType.t === 'MaybeSpecified'){
    return {t:inType.t, c:[replaceAnInType(nos, replaceWith, inType.c[0])]};
  }else if (inType.t === 'Object'){
    var c = inType.c.map((anInside, index)=>{
      var p = replaceAnInType(nos, replaceWith, anInside);
      p.ti = anInside.ti;
      return p;
    })
    return {t:'Object',c};
  }else{
    return inType;
  }

}
function replaceMatchAndFreeTypes(outExtract, inTypes){
  var newInTypes = inTypes;
  outExtract.forEach((aOutExtract, index0)=>{
    newInTypes = inTypes.map((anInType, index)=>{
      return replaceAnInType(aOutExtract.n, aOutExtract.s, anInType);
    }) 
  })
  return newInTypes;
}

function checkFormulaMatchesType(formulaToCheck, type, currentList, upwardInfo, entityPath, screenPath, chains){

  try{
    var objectType = TypeEvaluation.evalType(formulaToCheck, entityPath, currentList, upwardInfo);
    if (objectType instanceof Error ){
      return {t:objectType.message, loc:entityPath, screenPath}
    }
    var match = TypeChecks.checkMatch(objectType, type, true);

    if (!match){

      console.log(objectType);
      console.log(formulaToCheck);
      console.log(entityPath);
      console.log(type);
      console.log(upwardInfo);
      var tOut = 'Types do not match';
      if (objectType.t === 'toDelete' && objectType.msg){
        tOut = objectType.msg;
      }
      return {t:tOut, loc:entityPath, screenPath};
    }

    var ft = formulaToCheck.t;
    //from here on its about checking the subinputs.

    if (ft === 'f'){
      if (formulaToCheck.i === 61){
        for (var i3 = 0; i3 < formulaToCheck.v.length; i3++){
          var vToCheck = formulaToCheck.v[i3];
          if (type.t === 'any'){
              var p7 = checkFormulaMatchesType(vToCheck, type, currentList, upwardInfo, entityPath, screenPath, chains);
              if (p7.loc){
                return p7;
              }
          }else{
            for (var i4 = 0; i4 < type.c.length; i4++){
              if (type.c[i4].ti === vToCheck.ti){
                var p4 = checkFormulaMatchesType(vToCheck, type.c[i4], currentList, upwardInfo, entityPath, screenPath, chains);
                if (p4.loc){
                  return p4;
                }
                break;
              }
            }

          }
        }
      }else{
       var fn = StandardFns.functionalPieces[formulaToCheck.i];
       var outType = fn.out;
       var inTypes = fn.in;

       if (fn.net){
        var network = CoreFns.currencyOfDatabase(currentList, chains);
        if (fn.net !== network){
          return {t:'Invalid Option for Network', loc:entityPath, screenPath};
        }
       }

       var outExtract = extractAnyOrMatchTypes(objectType, outType);
       var newInTypes = replaceMatchAndFreeTypes(outExtract, inTypes);
       var downwardValueToAdd = [];
       for (var i = 0; i < formulaToCheck.v.length; i++){
        var tgtType;
        if (i < newInTypes.length){
          tgtType = newInTypes[i];
        }else{
          tgtType = newInTypes[newInTypes.length - 1];
        }
        if ((fn.i === 58 || fn.i === 59) && i === 1){
          var objectTypeToAdd = TypeEvaluation.evalType(formulaToCheck.v[0], entityPath, currentList, upwardInfo);
          downwardValueToAdd = [{t:formulaToCheck.m0, type:objectTypeToAdd.c}];
        }
        if (fn.i === 24 && i === 1){
          var objectTypeToAdd3 = TypeEvaluation.evalType(formulaToCheck.v[0], entityPath, currentList, upwardInfo);
          downwardValueToAdd = [{t:formulaToCheck.m0, type:objectTypeToAdd3.c}, {t:formulaToCheck.m1, type:objectTypeToAdd3.c}];
        }

        if (fn.i === 71 && i === 2){
          var objectTypeToAdd1 = TypeEvaluation.evalType(formulaToCheck.v[0], entityPath, currentList, upwardInfo);
          var objectTypeToAdd2 = TypeEvaluation.evalType(formulaToCheck.v[1], entityPath, currentList, upwardInfo); //i think this may require adding something to upwardInfos
          downwardValueToAdd = [{t:formulaToCheck.m0, type:objectTypeToAdd1.c},{t:formulaToCheck.m1, type:objectTypeToAdd2}];
        }
        var p = checkFormulaMatchesType(formulaToCheck.v[i], tgtType, currentList, upwardInfo.concat(downwardValueToAdd), entityPath, screenPath, chains);
        if (p.loc){
          return p;
        }else{
         var inExtract = extractAnyOrMatchTypes(p, tgtType);
         newInTypes = replaceMatchAndFreeTypes(inExtract, newInTypes);
        }
       }

      }
    }else if (CoreFns.withP(ft) || ft === 'eS'){
      if (ft === 'eS'){
        var thisAbi = ResponsiveFns.getToRelevantAbi(formulaToCheck, currentList); 
        if (thisAbi){
          for (var i5 = 0; i5 < formulaToCheck.v.length; i5++){
            var tgtType5;
            if (i5 < thisAbi.inputs.length){
             tgtType5 = TypeEvaluation.convertSCTypeToInternalType(thisAbi.inputs[+i5], currentList);
            // }else if (i5 < thisAbi.inputs.length + TypeEvaluation.countLists(formulaToCheck.p)){
            //   tgtType5 = {t:'UInteger'};
            }else{
              tgtType5 = {t:'ListType', c:{t:'ScEvent'}};
            }
            var p6 = checkFormulaMatchesType(formulaToCheck.v[i5], tgtType5, currentList, upwardInfo, entityPath, screenPath, chains);
            if (p6.loc){
              return p6;
            }
          }

        }
      }
      var pathDown = formulaToCheck.p;
      for (var j = 0; j < pathDown.length; j++){
        var aPath = pathDown[j];
        if (aPath.t === 'oP'){
        }else{
          var p2 = checkFormulaMatchesType(aPath, {t:'UInteger'}, currentList, upwardInfo, entityPath, screenPath, chains);
          if (p2.loc){
            return p2;
          }
        }
      }
    }else if (ft === 'eV'){
      var thisAbi1 = ResponsiveFns.getToRelevantAbi(formulaToCheck, currentList); 
      if (thisAbi1){
        var liveInputNos = 0;
        thisAbi1.inputs.forEach((anInput, index)=>{
          if (anInput.indexed){
            var tgtType51 = TypeEvaluation.convertSCTypeToInternalType(anInput, currentList);
            var p61 = checkFormulaMatchesType(formulaToCheck.v[liveInputNos], {t:'MaybeSpecified', c:[tgtType51]}, currentList, upwardInfo, entityPath, screenPath, chains);
            if (p61.loc){
              return p61;
            }
            liveInputNos ++;
          }
        })

      }
    }else if (ft === 'pa' || ft === 'al'){
      var valV = formulaToCheck.v;
      var itemName = 'Panel';
      if (ft === 'al'){
        itemName = 'Banner';
      }
      if (valV.length === 0){
        return {t:'Unspecified ' + itemName, loc:entityPath, screenPath};
      }
      try{
        if (!CoreFns.goDownPath(currentList, valV)){
          return {t:'Missing ' + itemName, loc:entityPath, screenPath};        
        }
      }catch(e){
        return {t:'Missing ' + itemName, loc:entityPath, screenPath};
      }
    }else if (ft === 'footer'){
      if (currentList.fo && currentList.fo.on){
      }else{
        return {t:'Footer no longer used', loc:entityPath, screenPath}
      }
    }else if (ft === 'pu'){
      var pu = currentList.pu;
      if (pu){
        if (pu[formulaToCheck.v]){
        }else{
          return {t:'Invalid Pop Up', loc:entityPath, screenPath};
        }
      }
    }else if (ft === 'scr'){
      var feSet = currentList.fe;
      if (!feSet[formulaToCheck.v] && formulaToCheck.v !== '_placeholderPage'){
        return {t:'Invalid Page', loc:entityPath, screenPath};
      }
    }else if (ft === 'mus'){
      var muSet = currentList.mu;
      if (!muSet[formulaToCheck.v]){
        return {t:'Invalid Music', loc:entityPath, screenPath};
      }
    }else if (ft === 's' || ft === 'ca' ||  ft === 'ad' || ft === 'ui' || ft === 'dt' || ft === 'i'|| ft === 'dc' || ft === 'pl' || ft === 'coin' || ft === 'curr'){


    }else{
      console.warn(formulaToCheck);
    }

    return objectType;
  }catch(err){
    return {t:err.message, loc:entityPath, screenPath};
  }
}


function oneOf(x, list){
  for (var i = 0; i < list.length; i++){
    if (x === list[i]){
      return true;
    }
  }
  return false;
}

